import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const AtlassianAnalytics = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "jira-software-pricing.modal-content.atlassian-analytics.title",
            defaultMessage: "Atlassian Analytics"
        }),
        body: intl.formatMessage({
            id: "jira-software-pricing.modal-content.atlassian-analytics.body",
            defaultMessage:
                "Build interactive, customizable charts, and dashboards across products and instances with a low- to no-code editor."
        }),
        link: intl.formatMessage(
            {
                id: "jira-software-pricing.modal-content.atlassian-analytics.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about Atlassian Analytics."
            },
            {
                learnMore: (chunks: React.ReactNode) => (
                    <a
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        href={useLocalizedHref("/platform/analytics")}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraSoftware"
                        data-label-english="Learn more"
                    >
                        {chunks}
                    </a>
                )
            }
        )
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </div>
    );
};

export default AtlassianAnalytics;
